// extracted by mini-css-extract-plugin
export default {"container":"GeoTab_container__VYI0M","loadingWrapper":"GeoTab_loadingWrapper__mTDEi","gridWrapper":"GeoTab_gridWrapper__R52VE"};